import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../../lib/api";
import StatusBadge from "../../components/StatusBadge";

export default function AdminIscrittoDettaglio() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/admin/iscritti/${id}`).then((res) => setData(res.data)).catch(() => {});
  }, [id]);

  if (!data) return <div className="mx-auto max-w-5xl px-4 py-16 text-sm text-muted-foreground">Caricamento...</div>;

  const u = data.iscritto;

  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8" data-testid="admin-iscritto-dettaglio">
      <Link to="/admin/iscritti" data-testid="admin-iscritto-back" className="inline-flex items-center gap-1 text-sm font-semibold text-bordeaux hover:underline">
        <ArrowLeft className="h-4 w-4" /> Iscritti
      </Link>

      <div className="card-elegant mt-6">
        <h1 className="font-heading text-2xl font-bold text-bordeaux-dark" data-testid="admin-iscritto-nome">
          {u.nome} {u.cognome}
        </h1>
        <dl className="mt-4 grid gap-x-8 gap-y-2 text-sm sm:grid-cols-2">
          <div><dt className="text-muted-foreground">Email</dt><dd className="font-medium">{u.email}</dd></div>
          <div><dt className="text-muted-foreground">Codice Fiscale</dt><dd className="font-medium tracking-wider">{u.codice_fiscale}</dd></div>
          <div><dt className="text-muted-foreground">Data iscrizione</dt><dd className="font-medium">{new Date(u.created_at).toLocaleDateString("it-IT")}</dd></div>
          <div><dt className="text-muted-foreground">Richieste di agibilità</dt><dd className="font-medium">{data.richieste.length}</dd></div>
        </dl>
      </div>

      <h2 className="mt-8 font-heading text-xl font-semibold text-bordeaux-dark">Richieste dell'iscritto</h2>
      <div className="mt-4 space-y-3">
        {data.richieste.length === 0 && (
          <p className="card-elegant text-center text-sm text-muted-foreground" data-testid="admin-iscritto-no-richieste">Nessuna richiesta effettuata.</p>
        )}
        {data.richieste.map((r) => (
          <div key={r.id} className="card-elegant !p-5" data-testid={`admin-iscritto-richiesta-${r.numero_pratica}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-heading font-bold text-bordeaux-dark">{r.numero_pratica}</p>
                <p className="text-sm text-muted-foreground">
                  {r.nome_locale} · {r.attivita} · € {r.importo.toFixed(2)} · Esibizione del {new Date(r.data_esibizione).toLocaleDateString("it-IT")}
                </p>
              </div>
              <StatusBadge stato={r.stato} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
